import { Suspense } from 'react';

import { useRuntime } from './internal';

export const XingSuspense: React.FC<
  React.PropsWithChildren<{ fallback?: React.ReactNode }>
> = ({ children, fallback = null }) => {
  const runtime = useRuntime();
  const { loginState } = runtime.config;

  if (runtime.isServer && loginState !== 'LOGGED_OUT') {
    return fallback;
  }

  return <Suspense fallback={fallback}>{children}</Suspense>;
};
